{
  "finder": {
    "searchInput": "finder-search-input",
    "submit": "finder-submit",
    "suggestion": "finder-suggestion",
    "clear": "finder-clear",
    "providerFilter": "finder-provider-filter",
    "providerFilterInput": "finder-provider-filter-input",
    "providerFilterSuggestion": "finder-provider-filter-suggestion",
    "viewToggleList": "finder-view-toggle-list",
    "viewToggleMap": "finder-view-toggle-map",
    "mapContainer": "finder-map-container",
    "mapPanel": "finder-map-panel",
    "mapBoundsSearch": "finder-map-bounds-search",
    "specialtyFilter": "finder-specialty-filter",
    "specialtyFilterInput": "finder-specialty-filter-input",
    "specialtyFilterOption": "finder-specialty-filter-option",
    "visitTypeFilter": "finder-visit-type-filter",
    "visitTypeFilterOption": "finder-visit-type-filter-option",
    "insuranceFilter": "finder-insurance-filter",
    "insuranceFilterInput": "finder-insurance-filter-input",
    "insuranceFilterOption": "finder-insurance-filter-option",
    "distanceFilterInput": "finder-distance-filter-input",
    "distanceFilterOption": "finder-distance-filter-option",
    "distanceSliderInput": "finder-distance-slider-input",
    "dateFilterInput": "finder-date-filter-input",
    "dateFilterDay": "finder-date-filter-day",
    "availabilityFilter": "finder-availability-filter",
    "acceptingNewPatientsFilter": "finder-accepting-new-patients-filter",
    "acceptingNewPatientsOption": "finder-accepting-new-patients-option",
    "ageGroupFilter": "finder-age-group-filter",
    "bodySystemFilter": "finder-body-system-filter",
    "categoryFilter": "finder-category-filter",
    "facilityFilter": "finder-facility-filter",
    "facilityFilterOption": "finder-facility-filter-option",
    "facilityFilterSearch": "finder-facility-filter-search",
    "facilityFilterBranchToggle": "finder-facility-filter-branch-toggle",
    "genderFilter": "finder-gender-filter",
    "languageFilter": "finder-language-filter",
    "listFilterOption": "finder-list-filter-option",
    "listFilterAnyOption": "finder-list-filter-any-option",
    "listFilterSearch": "finder-list-filter-search",
    "listFilterClear": "finder-list-filter-clear",
    "lgbtqiaAffirmingCareFilter": "finder-lgbtqia-affirming-care-filter",
    "lgbtqiaAffirmingCareOption": "finder-lgbtqia-affirming-care-option",
    "nearFilter": "finder-near-filter",
    "telehealthFilter": "finder-telehealth-filter",
    "telehealthOption": "finder-telehealth-option",
    "availabilityPanel": "finder-availability-panel",
    "availabilityVisitType": "finder-availability-visit-type",
    "availabilityVisitTypeOption": "finder-availability-visit-type-option",
    "availabilityTime": "finder-availability-time",
    "availabilityTimeOption": "finder-availability-time-option",
    "availabilityDate": "finder-availability-date",
    "availabilityDateToday": "finder-availability-date-today",
    "availabilityDateDayOfWeek": "finder-availability-date-day-of-week",
    "availabilityDateSpecificDay": "finder-availability-date-specific-day",
    "availabilityCalendar": "finder-availability-calendar",
    "availabilityCalendarDay": "finder-availability-calendar-day",
    "availabilityCalendarPrevMonth": "finder-availability-calendar-prev-month",
    "availabilityCalendarNextMonth": "finder-availability-calendar-next-month",
    "availabilityOnlineBooking": "finder-availability-online-booking",
    "availabilityDay": "finder-availability-day",
    "availabilityTodayLink": "finder-availability-today-link",
    "filterClear": "finder-filter-clear",
    "resultLink": "finder-result-link",
    "sort": "finder-sort",
    "sortToggle": "finder-sort-toggle",
    "sortOption": "finder-sort-option",
    "noResultsMessage": "finder-no-results-message",
    "paginationNext": "finder-pagination-next",
    "paginationPrev": "finder-pagination-prev",
    "sheetSearchInput": "finder-sheet-search-input",
    "mobileMap": "finder-mobile-map",
    "mobileMapBack": "finder-mobile-map-back",
    "mobileMapExternal": "finder-mobile-map-external",
    "showOnMap": "finder-show-on-map",
    "dialogDone": "finder-dialog-done",
    "backToSearch": "finder-back-to-search",
    "filterBarScrollStart": "finder-filter-bar-scroll-start",
    "filterBarScrollEnd": "finder-filter-bar-scroll-end",
    "filterMenuTrigger": "finder-filter-menu-trigger",
    "filterMenuPanel": "finder-filter-menu-panel",
    "filterMenuRow": "finder-filter-menu-row",
    "filterMenuRowClear": "finder-filter-menu-row-clear",
    "filterMenuReset": "finder-filter-menu-reset",
    "filterMenuDone": "finder-filter-menu-done"
  },
  "insurance": {
    "planActivator": "insurance-plan-activator",
    "networkBadge": "insurance-network-badge"
  },
  "slots": {
    "slot": "slots-slot",
    "fullSchedule": "slots-full-schedule",
    "entrySummary": "slots-entry-summary",
    "pickerSlot": "slots-picker-slot"
  },
  "profile": {
    "backToSearch": "profile-back-to-search",
    "name": "profile-name",
    "locations": "profile-locations",
    "specialties": "profile-specialties",
    "biography": "profile-biography",
    "externalProfessionalRelationships": "profile-external-professional-relationships",
    "insurance": "profile-insurance",
    "ratings": "profile-ratings",
    "features": "profile-features"
  },
  "booking": {
    "patientNew": "booking-patient-new",
    "patientReturning": "booking-patient-returning",
    "ageInRange": "booking-age-in-range",
    "ageOutOfRange": "booking-age-out-of-range",
    "choice": "booking-choice",
    "visitType": "booking-visit-type",
    "select": "booking-select",
    "guest": "booking-guest",
    "next": "booking-next",
    "back": "booking-back",
    "continue": "booking-continue",
    "verifyId": "booking-verify-id",
    "verifyIdError": "booking-verify-id-error",
    "confirmation": "booking-confirmation",
    "error": "booking-error",
    "fatalError": "booking-fatal-error",
    "cancel": "booking-cancel",
    "cancelReason": "booking-cancel-reason",
    "cancelComments": "booking-cancel-comments",
    "cancelSubmit": "booking-cancel-submit",
    "cancelled": "booking-cancelled"
  },
  "registration": {
    "firstName": "registration-first-name",
    "lastName": "registration-last-name",
    "insuranceSameAsLastVisit": "registration-insurance-same-as-last-visit",
    "insuranceChanged": "registration-insurance-changed",
    "insuranceSelfPay": "registration-insurance-self-pay",
    "insuranceReview": "registration-insurance-review",
    "dob": "registration-dob",
    "birthday": "registration-birthday",
    "gender": "registration-gender",
    "ssn": "registration-ssn",
    "email": "registration-email",
    "emailAddress": "registration-email-address",
    "phone": "registration-phone",
    "phoneNumber": "registration-phone-number",
    "street": "registration-street",
    "streetLine2": "registration-street-line-2",
    "city": "registration-city",
    "state": "registration-state",
    "zip": "registration-zip",
    "payor": "registration-payor",
    "memberNumber": "registration-member-number",
    "groupNumber": "registration-group-number",
    "symptoms": "registration-symptoms"
  },
  "login": {
    "email": "login-email",
    "password": "login-password",
    "submit": "login-submit"
  },
  "events": {
    "searchInput": "events-search-input",
    "searchSubmit": "events-search-submit",
    "resultItem": "events-result-item",
    "sessionItem": "events-session-item",
    "showMore": "events-show-more",
    "register": "events-register",
    "continue": "events-continue",
    "payment": "events-payment",
    "confirmation": "events-confirmation",
    "waitlistJoin": "events-waitlist-join",
    "waitlistSubmit": "events-waitlist-submit",
    "waitlisted": "events-waitlisted",
    "resultsList": "events-results-list",
    "categoryFilter": "events-category-filter",
    "categoryFilterOption": "events-category-filter-option",
    "categoryFilterSearch": "events-category-filter-search",
    "categoryFilterClear": "events-category-filter-clear"
  },
  "pagination": {
    "next": "pagination-next"
  },
  "nav": {
    "hamburger": "nav-hamburger",
    "mobileMenu": "nav-mobile-menu"
  },
  "admin": {
    "indexSearch": "admin-index-search",
    "indexSearchSubmit": "admin-index-search-submit",
    "indexNew": "admin-index-new",
    "indexSort": "admin-index-sort",
    "indexFilters": "admin-index-filters",
    "indexStatusFilter": "admin-index-status-filter",
    "indexTable": "admin-index-table",
    "indexCount": "admin-index-count",
    "indexRecordLink": "admin-index-record-link",
    "settingsPersonalInfo": "admin-settings-personal-info",
    "settingsAddresses": "admin-settings-addresses",
    "providerFirstName": "admin-provider-first-name",
    "providerLastName": "admin-provider-last-name",
    "addAddress": "admin-add-address",
    "addressLine": "admin-address-line",
    "addressCity": "admin-address-city",
    "addressZip": "admin-address-zip",
    "addressState": "admin-address-state",
    "addressEmailTab": "admin-address-email-tab",
    "addEmailAddress": "admin-add-email-address",
    "emailAddress": "admin-email-address",
    "settingsEmployment": "admin-settings-employment",
    "providerNPI": "admin-provider-npi",
    "settingsLicenses": "admin-settings-licenses",
    "addLicense": "admin-add-license",
    "licenseNumber": "admin-license-number",
    "licenseState": "admin-license-state",
    "licensePrimary": "admin-license-primary",
    "settingsCertifications": "admin-settings-certifications",
    "settingsDegrees": "admin-settings-degrees",
    "settingsSpecialties": "admin-settings-specialties",
    "addCertification": "admin-add-certification",
    "addProfileVideo": "admin-add-profile-video",
    "removeProfileVideo": "admin-remove-profile-video",
    "certificationCertificate": "admin-certification-certificate",
    "certificationYear": "admin-certification-year",
    "removeCertification": "admin-remove-certification",
    "degreeSearch": "admin-degree-search",
    "specialtySearch": "admin-specialty-search",
    "assignmentResult": "admin-assignment-result",
    "assignmentItem": "admin-assignment-item",
    "indexRow": "admin-index-row",
    "indexRecordSelect": "admin-index-record-select",
    "bulkActionsMenu": "admin-bulk-actions-menu",
    "bulkInviteForReview": "admin-bulk-invite-for-review",
    "save": "admin-save",
    "publishStatus": "admin-publish-status",
    "archive": "admin-archive",
    "confirm": "admin-confirm",
    "settingsPatients": "admin-settings-patients",
    "providerJobTitle": "admin-provider-job-title",
    "providerAgeGroup": "admin-provider-age-group",
    "downloadPdf": "admin-download-pdf",
    "machineTranslate": "admin-machine-translate",
    "bulkMachineTranslate": "admin-bulk-machine-translate",
    "bulkTranslateWithClara": "admin-bulk-translate-with-clara",
    "bulkTranslateField": "admin-bulk-translate-field",
    "bulkTranslateLanguage": "admin-bulk-translate-language",
    "bulkTranslateReplace": "admin-bulk-translate-replace",
    "translatableField": "admin-translatable-field",
    "translatableFieldLanguage": "admin-translatable-field-language",
    "translatableFieldLanguageOption": "admin-translatable-field-language-option",
    "translatableFieldTranslate": "admin-translatable-field-translate",
    "translatableFieldTranslateLocale": "admin-translatable-field-translate-locale",
    "translatableFieldTranslateSubmit": "admin-translatable-field-translate-submit"
  },
  "profileReview": {
    "open": "profile-review-open",
    "firstName": "profile-review-first-name",
    "lastName": "profile-review-last-name",
    "email": "profile-review-email",
    "send": "profile-review-send",
    "message": "profile-review-message"
  },
  "review": {
    "start": "review-start",
    "listItem": "review-list-item",
    "backToDashboard": "review-back-to-dashboard",
    "status": "review-status",
    "actionMenu": "review-action-menu",
    "cancel": "review-cancel",
    "startNew": "review-start-new",
    "submit": "review-submit",
    "submitConfirm": "review-submit-confirm",
    "cancelConfirm": "review-cancel-confirm",
    "cancelError": "review-cancel-error",
    "changeset": "review-changeset",
    "changesetEntry": "review-changeset-entry",
    "entryToggle": "review-entry-toggle",
    "partialResolveConfirm": "review-partial-resolve-confirm",
    "endReviewConfirm": "review-end-review-confirm",
    "addComment": "review-add-comment",
    "changesetAddComment": "review-changeset-add-comment",
    "comment": "review-comment",
    "commentInput": "review-comment-input",
    "commentSubmit": "review-comment-submit",
    "resolve": "review-resolve",
    "decline": "review-decline",
    "requestStart": "review-request-start",
    "requestInvitees": "review-request-invitees",
    "requestInviteeOption": "review-request-invitee-option",
    "requestSubmit": "review-request-submit",
    "requestListItem": "review-request-list-item",
    "requestActionMenu": "review-request-action-menu",
    "requestResend": "review-request-resend",
    "requestCancel": "review-request-cancel",
    "requestTab": "review-request-tab",
    "bulkRequestSubmit": "review-bulk-request-submit"
  },
  "assignSpecialties": {
    "termInput": "assign-specialties-term-input",
    "dropzone": "assign-specialties-dropzone",
    "specialtySelect": "assign-specialties-specialty-select",
    "modeSelect": "assign-specialties-mode-select",
    "clientControlToggle": "assign-specialties-client-control-toggle",
    "previewButton": "assign-specialties-preview-button",
    "confirmButton": "assign-specialties-confirm-button",
    "backButton": "assign-specialties-back-button",
    "previewRow": "assign-specialties-preview-row",
    "flagOutcome": "assign-specialties-flag-outcome"
  },
  "canonicalUpdate": {
    "previewRow": "canonical-update-preview-row",
    "confirmButton": "canonical-update-confirm",
    "cancelButton": "canonical-update-cancel",
    "changesCell": "canonical-update-changes"
  },
  "mstBulkActions": {
    "assignControlMode": "mst-bulk-assign-control-mode",
    "specialtySelect": "mst-bulk-assign-specialties-select",
    "assignSpecialtiesMode": "mst-bulk-assign-specialties-mode",
    "clientControlToggle": "mst-bulk-client-control-toggle"
  },
  "cta": {
    "mobileTeaserBar": "cta-mobile-teaser-bar",
    "mobileTeaser": "cta-mobile-teaser",
    "mobileModal": "cta-mobile-modal",
    "mobileModalClose": "cta-mobile-modal-close"
  },
  "clara": {
    "promptInput": "clara-prompt-input",
    "promptSend": "clara-prompt-send",
    "modal": "clara-modal",
    "modalClose": "clara-modal-close",
    "composerInput": "clara-composer-input",
    "composerSend": "clara-composer-send",
    "message": "clara-message",
    "copy": "clara-copy",
    "retry": "clara-retry",
    "regenerate": "clara-regenerate",
    "thumbsUp": "clara-thumbs-up",
    "thumbsDown": "clara-thumbs-down",
    "feedbackComment": "clara-feedback-comment",
    "feedbackSubmit": "clara-feedback-submit",
    "feedbackCancel": "clara-feedback-cancel",
    "scrollToBottom": "clara-scroll-to-bottom"
  },
  "dtAssistant": {
    "tab": "dt-assistant-tab",
    "componentsTab": "dt-assistant-components-tab",
    "panel": "dt-assistant-panel",
    "composerInput": "dt-assistant-composer-input",
    "composerSend": "dt-assistant-composer-send",
    "attach": "dt-assistant-attach",
    "attachedFile": "dt-assistant-attached-file",
    "updateNotice": "dt-assistant-update-notice",
    "applyAnyway": "dt-assistant-apply-anyway",
    "discard": "dt-assistant-discard",
    "revert": "dt-assistant-revert",
    "revertAnyway": "dt-assistant-revert-anyway",
    "keepChanges": "dt-assistant-keep-changes",
    "warningShow": "dt-assistant-warning-show",
    "warningFix": "dt-assistant-warning-fix",
    "changesToggle": "dt-assistant-changes-toggle",
    "changeLink": "dt-assistant-change-link",
    "claraChip": "dt-assistant-clara-chip",
    "claraPopover": "dt-assistant-clara-popover"
  },
  "spotlight": {
    "item": "spotlight-item",
    "input": "spotlight-input"
  },
  "createDashboard": {
    "loadError": "create-dashboard-load-error",
    "groupTab": "create-dashboard-group-tab",
    "metricTile": "create-dashboard-metric-tile",
    "timelineChart": "create-dashboard-timeline-chart",
    "facetCard": "create-dashboard-facet-card",
    "facetDetailLink": "create-dashboard-facet-detail-link",
    "facetShowAll": "create-dashboard-facet-show-all",
    "facetLegendItem": "create-dashboard-facet-legend-item",
    "facetLegendMenu": "create-dashboard-facet-legend-menu",
    "facetFilterToggle": "create-dashboard-facet-filter-toggle",
    "appliedFilter": "create-dashboard-applied-filter",
    "clearFilters": "create-dashboard-clear-filters",
    "facetDetailBack": "create-dashboard-facet-detail-back",
    "chartTypeBar": "create-dashboard-chart-type-bar",
    "chartTypeLine": "create-dashboard-chart-type-line",
    "settingsMenu": "create-dashboard-settings-menu",
    "viewOptions": "create-dashboard-view-options",
    "percentageToggle": "create-dashboard-percentage-toggle",
    "resetDefaults": "create-dashboard-reset-defaults",
    "viewOptionsDone": "create-dashboard-view-options-done",
    "facetEmpty": "create-dashboard-facet-empty",
    "urlFilterAdd": "create-dashboard-url-filter-add",
    "urlFilterInput": "create-dashboard-url-filter-input",
    "urlFilterDone": "create-dashboard-url-filter-done",
    "urlFilterCancel": "create-dashboard-url-filter-cancel"
  },
  "matchDashboard": {
    "loadError": "match-dashboard-load-error",
    "bookingFlowTab": "match-dashboard-booking-flow-tab",
    "bookingFlowChart": "match-dashboard-booking-flow-chart",
    "bookingFlowMetricTile": "match-dashboard-booking-flow-metric-tile",
    "searchBehaviorCard": "match-dashboard-search-behavior-card",
    "searchBehaviorChart": "match-dashboard-search-behavior-chart",
    "metricTile": "match-dashboard-metric-tile",
    "facetCard": "match-dashboard-facet-card",
    "facetLegendItem": "match-dashboard-facet-legend-item",
    "facetLegendMenu": "match-dashboard-facet-legend-menu",
    "facetLegendFilter": "match-dashboard-facet-legend-filter",
    "appliedFilter": "match-dashboard-applied-filter",
    "clearFilters": "match-dashboard-clear-filters",
    "facetDetailLink": "match-dashboard-facet-detail-link",
    "facetDetailBack": "match-dashboard-facet-detail-back",
    "settingsMenu": "match-dashboard-settings-menu",
    "viewOptions": "match-dashboard-view-options",
    "percentageToggle": "match-dashboard-percentage-toggle",
    "viewOptionsDone": "match-dashboard-view-options-done"
  },
  "connectDashboard": {
    "dateRangeSelector": "connect-dashboard-date-range-selector",
    "dateRangeOption": "connect-dashboard-date-range-option",
    "filters": "connect-dashboard-filters",
    "filtersClearAll": "connect-dashboard-filters-clear-all",
    "callCenterFilter": "connect-dashboard-call-center-filter",
    "callCenterFilterOption": "connect-dashboard-call-center-filter-option",
    "teamFilter": "connect-dashboard-team-filter",
    "teamFilterOption": "connect-dashboard-team-filter-option",
    "metricTile": "connect-dashboard-metric-tile",
    "chart": "connect-dashboard-chart",
    "chartAxisLabel": "connect-dashboard-chart-axis-label",
    "callsTab": "connect-dashboard-calls-tab",
    "agentsTab": "connect-dashboard-agents-tab",
    "tabsActionsMenu": "connect-dashboard-tabs-actions-menu",
    "allCallsLink": "connect-dashboard-all-calls-link",
    "allAgentsLink": "connect-dashboard-all-agents-link",
    "callsSort": "connect-dashboard-calls-sort",
    "callsSortOption": "connect-dashboard-calls-sort-option",
    "agentsSort": "connect-dashboard-agents-sort",
    "agentsSortOption": "connect-dashboard-agents-sort-option",
    "callsTable": "connect-dashboard-calls-table",
    "callsRow": "connect-dashboard-calls-row",
    "callsCallerCell": "connect-dashboard-calls-caller-cell",
    "callsStatusCell": "connect-dashboard-calls-status-cell",
    "agentsTable": "connect-dashboard-agents-table",
    "agentsRow": "connect-dashboard-agents-row",
    "agentsNameCell": "connect-dashboard-agents-name-cell",
    "agentsActions": "connect-dashboard-agents-actions",
    "agentsListenIn": "connect-dashboard-agents-listen-in",
    "agentsProfileLink": "connect-dashboard-agents-profile-link",
    "agentsEndShift": "connect-dashboard-agents-end-shift",
    "callModal": "connect-dashboard-call-modal",
    "callModalClose": "connect-dashboard-call-modal-close",
    "callModalPrev": "connect-dashboard-call-modal-prev",
    "callModalNext": "connect-dashboard-call-modal-next",
    "callSummaryContext": "connect-dashboard-call-summary-context",
    "callSummaryStatus": "connect-dashboard-call-summary-status",
    "callRecordingContext": "connect-dashboard-call-recording-context",
    "recordingPlayToggle": "connect-dashboard-recording-play-toggle",
    "recordingTranscript": "connect-dashboard-recording-transcript",
    "callCoachingContext": "connect-dashboard-call-coaching-context",
    "coachingToggle": "connect-dashboard-coaching-toggle",
    "activityMetricTile": "connect-dashboard-activity-metric-tile",
    "activitySort": "connect-dashboard-activity-sort",
    "activityGroupByCallCenter": "connect-dashboard-activity-group-by-call-center",
    "activitySortField": "connect-dashboard-activity-sort-field",
    "activitySortFieldOption": "connect-dashboard-activity-sort-field-option",
    "activityFilters": "connect-dashboard-activity-filters",
    "activityFiltersClearAll": "connect-dashboard-activity-filters-clear-all",
    "activityCallCenterFilter": "connect-dashboard-activity-call-center-filter",
    "activityCallCenterFilterOption": "connect-dashboard-activity-call-center-filter-option",
    "activityAgentStatusFilter": "connect-dashboard-activity-agent-status-filter",
    "activityAgentStatusFilterOption": "connect-dashboard-activity-agent-status-filter-option",
    "activityTeamFilter": "connect-dashboard-activity-team-filter",
    "activityTeamFilterOption": "connect-dashboard-activity-team-filter-option",
    "activityList": "connect-dashboard-activity-list",
    "activityGroup": "connect-dashboard-activity-group",
    "activityGroupToggle": "connect-dashboard-activity-group-toggle",
    "activityItem": "connect-dashboard-activity-item",
    "activityItemActions": "connect-dashboard-activity-item-actions",
    "activityListenIn": "connect-dashboard-activity-listen-in",
    "activityProfileLink": "connect-dashboard-activity-profile-link",
    "activityEndShift": "connect-dashboard-activity-end-shift",
    "activityToggleExpandAll": "connect-dashboard-activity-toggle-expand-all",
    "activityEmptyMessage": "connect-dashboard-activity-empty-message"
  },
  "dateRange": {
    "picker": "date-range-picker",
    "comparePicker": "date-range-compare-picker",
    "shortcutsMenu": "date-range-shortcuts-menu",
    "shortcut": "date-range-shortcut",
    "done": "date-range-done",
    "cancel": "date-range-cancel",
    "compareStart": "date-range-compare-start",
    "compareSwap": "date-range-compare-swap",
    "compareClear": "date-range-compare-clear"
  },
  "scheduleDateGenerator": {
    "trigger": "schedule-date-generator-trigger",
    "dates": "schedule-date-generator-dates",
    "datesDay": "schedule-date-generator-dates-day",
    "datesPrevMonth": "schedule-date-generator-dates-prev-month",
    "datesNextMonth": "schedule-date-generator-dates-next-month",
    "startTime": "schedule-date-generator-start-time",
    "endTime": "schedule-date-generator-end-time",
    "duration": "schedule-date-generator-duration",
    "interval": "schedule-date-generator-interval",
    "previewRow": "schedule-date-generator-preview-row",
    "confirm": "schedule-date-generator-confirm",
    "cancel": "schedule-date-generator-cancel"
  },
  "directoryPdf": {
    "activator": "directory-pdf-activator",
    "preparerName": "directory-pdf-preparer-name",
    "emails": "directory-pdf-emails",
    "consent": "directory-pdf-consent",
    "submit": "directory-pdf-submit",
    "download": "directory-pdf-download",
    "retry": "directory-pdf-retry",
    "emailConsent": "directory-pdf-email-consent",
    "emailSubmit": "directory-pdf-email-submit",
    "emailSent": "directory-pdf-email-sent",
    "emailFailed": "directory-pdf-email-failed",
    "emailNotSent": "directory-pdf-email-not-sent",
    "done": "directory-pdf-done",
    "cancel": "directory-pdf-cancel",
    "startOver": "directory-pdf-start-over",
    "staleNotice": "directory-pdf-stale-notice"
  },
  "dtBuilder": {
    "arrange": "dt-builder-arrange",
    "internalComment": "dt-builder-internal-comment",
    "internalCommentResolve": "dt-builder-internal-comment-resolve",
    "undo": "dt-builder-undo",
    "redo": "dt-builder-redo"
  },
  "messageComposer": {
    "applyTemplate": "message-composer-apply-template",
    "deliveryMethod": "message-composer-delivery-method",
    "send": "message-composer-send"
  }
}
